module.exports = __webpack_public_path__ + "static/media/mini_ironman.740f4a1d.png";